// 创建观察者
export function createInter(dom,option,callback){
  let interObserver = new IntersectionObserver(callback,option);
  interObserver.observe(dom);
  return interObserver
}

//弹窗提示 警告
export const popWFun = (text) => {
  let h = app.$createElement;
  app.$message({
      message: h('div', {}, [
          h('span', { style: { color: "#E6A23C", fontSize: "12px", position: "relative", top: "-1px" } }, text),
      ]),
      type:"warning",
      duration:1000,
      center:false,
      //icon:'InfoFilled'
  })
}

//弹窗提示 成功
export const popSFun = (text) => {
  app.$message({
      message:text,
      type:"success",
      duration: 1000,
      center: false,
      //icon:'InfoFilled'
  })
}

export default {
  createInter,
  popWFun,
  popSFun
}